import { IIconProps } from './Types';

export const SortingArrowInActiveIcon = ({ color = '#CBCBCB', size = 16 }: IIconProps) => {
  return (
    <svg
      fill="none"
      height="19"
      viewBox="0 0 16 19"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 11L8 19L16 11L0 11Z" fill={color} />
      <path d="M16 8L8 -8.18592e-07L-2.38419e-07 8L16 8Z" fill={color} />
    </svg>
  );
};
